// eslint-disable-next-line no-unused-vars
import React from 'react';
import ProductList from './ProductList';

const ProductListMenuSubsidiary = props => {
  return <ProductList dontOpenEdit {...props} />;
};
export default ProductListMenuSubsidiary;
